import { formatterWithMinutes } from 'module/ui/components/atoms/input-duration/formatter';
import { NoValue as EmptyCell } from 'module/ui/components/atoms/no-value/empty-cell';
import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';

export const HoursMinutesRenderer: FC<
  React.PropsWithChildren<ICellRendererParams>
> = ({ value }) => {
  if (!value) {
    return <EmptyCell />;
  }

  return <>{formatterWithMinutes(value)}</>;
};
